module.exports = __webpack_public_path__ + "media/images/athletes/4335-7e4dcdea50c015e21e30f8ca75e20a7c.png";